import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import FullProduct from '../../../models/product/FullProduct';
import FullProductMatrix from '../../../models/product/FullProductMatrix';
import { modelOf } from '../../../prop-types';
import ProductCollectionMatrixRow from '../ProductCollectionMatrixRow';

const ProductCollectionMatrixTableBody = ({
  product,
  productMatrix,
  ifProductRowImages,
  tooltipStates,
  onImageClick,
  onQuantityChange,
}) => {
  return (
    <tbody>
      {productMatrix.getColumnElements().map((element) => (
        <ProductCollectionMatrixRow
          key={element.id}
          element={element}
          product={product}
          productMatrix={productMatrix}
          ifProductRowImages={ifProductRowImages}
          tooltipStates={tooltipStates}
          onImageClick={onImageClick}
          onQuantityChange={onQuantityChange}
          isLeftAligned={productMatrix.isLeftAligned}
        />
      ))}
    </tbody>
  );
};

ProductCollectionMatrixTableBody.propTypes = {
  product: modelOf(FullProduct).isRequired,
  productMatrix: modelOf(FullProductMatrix).isRequired,
  ifProductRowImages: PropTypes.func,
  tooltipStates: PropTypes.object.isRequired,
  onImageClick: PropTypes.func.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
};

export default observer(ProductCollectionMatrixTableBody);
